import React from 'react';
import { makeStyles, Tooltip as MaterialTooltip } from '@material-ui/core';
import WarnIcon from '@material-ui/icons/ReportProblem';
import InfoIcon from '@material-ui/icons/Info';
import Icons from 'components/Icons';
import classnames from 'classnames';

const useStyles = makeStyles({
  icon: {
    width: '24px',
    height: '24px'
  },
  wrapper: {
    verticalAlign: 'bottom'
  }
});

interface Props {
  text: any;
  icon?: 'warn' | 'edit';
  onClick?: (e: any) => void;
  className?: any;
}

const renderIcon = (iconName: string | undefined) => {
  switch (iconName) {
    case 'warn':
      return <WarnIcon style={{ color: '#FDC941' }} />;
    case 'edit':
      return <Icons.Edit width={'24px'} style={{ cursor: 'pointer' }} />;
    default:
      return <InfoIcon />;
  }
};

const TooltipIcon = ({ text, icon, onClick, className }: Props) => {
  const classes = useStyles();
  return (
    <MaterialTooltip
      title={text}
      arrow
      className={classnames(classes.wrapper, className && className)}
      onClick={onClick}
    >
      {renderIcon(icon)}
    </MaterialTooltip>
  );
};

export default TooltipIcon;
